import { get } from 'lodash';

/**
 * Add the appropiate control for editing the mission geometry to the leaflet map
 * when the button to edit the geometry has been activated.
 *
 * @param {*} arg - The object argument.
 * @param {object} arg.leafletMap - The leaflet map object.
 * @param {boolean} arg.defineGeometryActive - A flag to check if the button to define area is active.
 * @param {object} arg.geometryLayer - The layer group for the mission geometry.
 * @param {object} arg.drawControl - The full draw control for the geometry layer.
 * @param {object} arg.editControl - The edition only draw control for the geometry layer.
 */
const showGeometryEditControls = ({
  leafletMap,
  defineGeometryActive,
  drawControl,
  editControl,
  geometryLayer
}) => {
  if (defineGeometryActive) {
    let button;
    if (geometryLayer.getLayers().length === 0) {
      leafletMap.addControl(drawControl);
      // eslint-disable-next-line no-underscore-dangle
      button = drawControl._container;
    } else {
      leafletMap.addControl(editControl);
      // eslint-disable-next-line no-underscore-dangle
      button = editControl._container;
    }
    button.style.visibility = 'visible';
    button.style.opacity = 1;
    button.style.bottom = '0px';
    if (get(leafletMap, ['collapseButton', 'container', 'title']) === 'Expandir') {
      button.style.visibility = 'hidden';
      button.style.opacity = 0;
      button.style.bottom = '200px';
    }
  } else if (!defineGeometryActive) {
    leafletMap.removeControl(drawControl);
    leafletMap.removeControl(editControl);
  }
};

export default showGeometryEditControls;
